import { FormControl } from '@angular/forms';
import { ApplianceDetailsFormField } from '../../models/appliance-details/appliance-details-form-field.enum';
import { ApplianceDetailsForm } from '../../models/appliance-details/appliance-details-form.interface';

export const mockApplianceDetailsForm: ApplianceDetailsForm = {
  [ApplianceDetailsFormField.ApplianceCode]: new FormControl(null),
  [ApplianceDetailsFormField.BrandCode]: new FormControl(null),
  [ApplianceDetailsFormField.ModelNumber]: new FormControl(null),
  [ApplianceDetailsFormField.PartsWarranty]: new FormControl(null),
  [ApplianceDetailsFormField.PurchaseDate]: new FormControl(null),
  [ApplianceDetailsFormField.PurchasePrice]: new FormControl(null),
  [ApplianceDetailsFormField.Retailer]: new FormControl(null),
  [ApplianceDetailsFormField.SerialNumber]: new FormControl(null),
  [ApplianceDetailsFormField.Warranty]: new FormControl(null),
};
